import { render, staticRenderFns } from "./ContractsPopup.vue?vue&type=template&id=5045aeae"
import script from "./ContractsPopup.vue?vue&type=script&lang=js"
export * from "./ContractsPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports